import React from 'react';
import { Skeleton } from '@fourthwall/components';
import { calculateValuePercentageChange } from '../../../../utils/calculateValuePercentageChange';
import { isArrayValue } from '../../../../utils/isArrayValue';
import { AnalyticsChangeIndicator } from '../../../AnalyticsChangeIndicator/AnalyticsChangeIndicator';
import * as S from './StatsTypeAnalyticsCardContent.styled';
export const StatsTypeAnalyticsCardContent = ({ data, isLoading, emptyMessage = 'No data', formatValue, }) => {
    const displayValue = (value) => (formatValue ? formatValue(value) : value);
    if (isLoading) {
        return React.createElement(StatsTypeAnalyticsCardContentSkeleton, null);
    }
    if (!data.length) {
        return (React.createElement(S.Container, null,
            React.createElement(S.EmptyMessage, null, emptyMessage)));
    }
    return (React.createElement(S.Container, null, data.map((item, index) => {
        if (isArrayValue(item.value)) {
            const changeValue = calculateValuePercentageChange(item.value);
            return (React.createElement(S.Item, { key: index },
                React.createElement(S.Label, null, item.label),
                React.createElement(S.Value, null, displayValue(item.value[0])),
                React.createElement(S.ChangeValue, null,
                    React.createElement(AnalyticsChangeIndicator, { value: changeValue }))));
        }
        return (React.createElement(S.Item, { key: index },
            React.createElement(S.Label, null, item.label),
            React.createElement(S.Value, null, displayValue(item.value))));
    })));
};
const StatsTypeAnalyticsCardContentSkeleton = () => (React.createElement(S.Container, null, [...Array(8)].map((_, index) => {
    return (React.createElement(S.Item, { key: index },
        React.createElement(S.Label, null,
            React.createElement(Skeleton.Shape, { width: "100%", height: 24 })),
        React.createElement(S.Value, null,
            React.createElement(Skeleton.Shape, { width: 80, height: 24 }))));
})));
